import {
  loadAutomationByIdFromApi,
  normalizeWorkflow,
  saveAutomationViaApi,
} from "../automations/automationStorage";

/**
 * Save a new workflow at the end of its automation's list (the shared
 * saveWorkflowOnAutomationViaApi puts new ones first).
 */
export const appendWorkflowOnAutomationViaApi = async (
  automationId,
  workflow
) => {
  const { automation: parent } = await loadAutomationByIdFromApi(automationId);
  if (!parent) throw new Error("Automation not found");
  const next = normalizeWorkflow({
    ...workflow,
    updatedAt: new Date().toISOString(),
  });
  const others = (parent.workflows || []).filter((item) => item.id !== next.id);
  return saveAutomationViaApi({ ...parent, workflows: [...others, next] });
};
